import React from 'react';

export function BaseCredentials() {
    return (
        <div>
            <h1>Base Credential TODO.s</h1>
        </div>
    );
}
